<template lang="pug">
.reservation-message-modal
  b-modal(v-model="_modalShow" size="lg" no-close-on-backdrop no-close-on-esc @ok="onSend" @cancel="cancel")
    template(#modal-title)
      span {{ modalTitle }}

    .d-flex.flex-column(v-if="modalMessage")
      p(style="white-space: pre-wrap; word-wrap: break-word;") {{ modalMessage }}
    .register-body
      FormInput(v-model="_title" name="title" key-name="タイトル" type="text" placeholder="タイトル"
        :maxlength="100" :validation-rules="{ required: true, max: 100 }" :styles="{ width: '720px' }" required)
      FormTextarea(v-model="_text" name="text" key-name="本文" placeholder="本文"
        :maxlength="1000" :validation-rules="{ required: true, max: 1000 }" :styles="{ maxWidth: '720px', width: '720px', minHeight: '160px' }" required)

    .testmail-modal-footer(slot="modal-footer" slot-scope="{ ok, cancel }" style="width:100%;")
      ValidationAlert(v-model="_showValidationAlert")
      .buttons.d-flex.justify-content-end
        button.btn.modal-ok-btn(type="button" @click="ok()") 送信
        button.btn.modal-cancel-btn(type="button" @click="cancel()") キャンセル
</template>

<script lang="ts">
import { Component, Prop, Vue } from "vue-property-decorator";

import ValidationAlert from "@/pc/basics/ValidationAlertByValidator.vue";
import FormInput from "@/pc/components/forms/FormInput.vue";
import FormTextarea from "@/pc/components/forms/FormTextarea.vue";

/**
 * ### メッセージ送信内容入力モーダル
 */
@Component({
  components: {
    ValidationAlert,
    FormInput,
    FormTextarea
  },
  $_veeValidate: { validator: "new" }
})
export default class MessageModal extends Vue {
  @Prop()
  value!: boolean;
  /** モーダルタイトル */
  @Prop()
  modalTitle!: string;
  /** モーダルメッセージ */
  @Prop()
  modalMessage!: string;
  /** メッセージタイトル */
  @Prop()
  title!: string;
  /** メッセージ本文 */
  @Prop()
  text!: string;

  /** バリデーションアラート表示可否 */
  showValidationAlert: boolean = false;

  get _modalShow(): boolean {
    return this.value;
  }

  set _modalShow(newValue: boolean) {
    this.$emit("input", newValue);
    return;
  }

  get _title(): string {
    return this.title;
  }

  set _title(newValue: string) {
    this.$emit("update:title", newValue);
    return;
  }

  get _text(): string {
    return this.text;
  }

  set _text(newValue: string) {
    this.$emit("update:text", newValue);
    return;
  }

  get _showValidationAlert(): boolean {
    return this.showValidationAlert;
  }

  set _showValidationAlert(newValue: boolean) {
    this.showValidationAlert = false;
    return;
  }

  /**
   * ### 送信ボタン押下処理
   *
   * - モーダルを非表示にするか否かは親コンポーネントに移譲する
   */
  public async onSend(modalEvent: any): Promise<void> {
    modalEvent.preventDefault();
    const validationResult: boolean = await this.$validator.validateAll();
    if (validationResult) {
      this.showValidationAlert = false;
      this.$emit("onSend");
    } else {
      this.showValidationAlert = true;
    }
    return;
  }

  public cancel(): void {
    this.showValidationAlert = false;
    return;
  }
}

export enum TestMailTargetType {
  /** 種別無し */
  NONE = 0,
  /** 家族ユーザー */
  FAMILY = 1,
  /** 施設関係者 */
  OTHER_USER_GROUP_MEMBER = 2
}
</script>
